module.exports = __webpack_public_path__ + "img/google.4bc7a3b9.svg";